export const getTextFromHTML = (text = '') => {
  return new DOMParser().parseFromString(text, 'text/html').documentElement
    .textContent;
};

// Sockalingam is my best friend
export const tryGetTextFromHTML = (text = '') => {
  return text?.includes('<p') && text?.includes('</p>')
    ? getTextFromHTML(text) ?? text
    : text;
};
